import { Container, Label } from 'components/atoms';
import { FormInput } from 'components/molecules';
import DataWrapper from 'components/molecules/data-wrapper/DataWrapper';
import HeaderStatusWrapper from 'components/molecules/headerStatusWrapper/HeaderStatusWrapper';
import { useFormikContext } from 'formik';
import { IFormikContextType } from 'hooks/useFormikField';
import { useTranslation } from 'react-i18next';
import {
  PiEye,
  PiImage,
  PiThumbsDown,
  PiThumbsUp,
  PiVideoCamera,
} from 'react-icons/pi';
import { IChannelVideoForm } from 'services/channel/types/query';

const ChannelData = () => {
  const { t } = useTranslation();

  const {
    values,
    setFieldValue,
    status,
    initialValues,
    errors,
  }: IFormikContextType<IChannelVideoForm> =
    useFormikContext<IChannelVideoForm>();

  return (
    <DataWrapper>
      <Container className='w-max'>
        <Container.Header
          title={
            <>
              <PiImage /> {t('input.label.image')}
            </>
          }
        />
        <Container.Content className='items-center'>
          <img
            src={values.videoImageLink}
            style={{ height: 120, borderRadius: '0.5rem' }}
          />
        </Container.Content>
      </Container>
      <Container>
        <Container.Header
          title={
            <>
              <PiVideoCamera /> {t('artist.tabs.data')}
            </>
          }
        />

        <Container.Content>
          <FormInput.Text
            displayMode={true}
            name='videoTitle'
            label={t('input.label.name')}
          />
          <FormInput.Text
            displayMode={true}
            name='externalVideoId'
            label={t('input.label.videoId')}
          />
        </Container.Content>
      </Container>{' '}
      <HeaderStatusWrapper title={t('channel.label.views')}>
        <Label title='Views' size='compact' withText fullWidth>
          <PiEye /> {values.views.toLocaleString()}
        </Label>
      </HeaderStatusWrapper>
      <HeaderStatusWrapper title={t('channel.label.likes')}>
        <Label title='Likes' size='compact' withText fullWidth>
          <PiThumbsUp /> {values.likesCount.toLocaleString()}
        </Label>
      </HeaderStatusWrapper>
      {!!values.dislikesCount && (
        <HeaderStatusWrapper title={t('channel.label.dislikes')}>
          <Label title='Dislikes' size='compact' withText fullWidth>
            <PiThumbsDown /> {values.dislikesCount.toLocaleString()}
          </Label>
        </HeaderStatusWrapper>
      )}
    </DataWrapper>
  );
};

export default ChannelData;
